import type { JSX } from 'react'
import type { ITextBoxProps } from '../TextBox'

import { TextBox } from '../TextBox'
import { Colors, TextAligning, TextBoxTypes } from '../TextBox.h'

export interface ITextBoxMaxLine1Button2Center extends ITextBoxProps {}

export const TextBoxMaxLine1Button2Center = ({
  title = '',
  color = Colors.TEXT_ICON_PRIMARY,
  font = TextBoxTypes.Button2,
  alignment = TextAligning.Center,
  maxLines = 1,
  ...rest
}: ITextBoxMaxLine1Button2Center): JSX.Element => (
  <TextBox
    title={title}
    color={color}
    font={font}
    alignment={alignment}
    maxLines={maxLines}
    {...rest}
  />
)
